import {t} from "i18next";

export const filterOutDeletedUsers = (savedInvestigations, usersList) => {
  const userIds = usersList.map((u) => u["user-id"]);
  const userNames = usersList.map((u) => u["user-name"]);

  savedInvestigations.map((investigation) => {
    let {owner, source, owner_name, ...newInvestigation} = investigation;
    newInvestigation = {...newInvestigation};
    if (owner && owner.length > 0) {
      owner = userIds.includes(owner) ? owner : t("users.deleted");
      newInvestigation.owner = owner;
    }
    if (source && source.length > 0) {
      source = userNames.includes(source) ? source : t("users.deleted");
      newInvestigation.source = source;
    }
    if (owner_name && owner_name.length > 0) {
      owner_name = userNames.includes(owner_name)
        ? owner_name
        : t("users.deleted");
      newInvestigation.owner_name = owner_name;
    }
  });
};

export const prettyPrintUsernamesFromArray = (array, usersList) => {
  return array.map((object) => {
    const user = usersList.find((user) => user["user-id"] === object.owner);
    return {...object, owner: user ? user?.["user-name"] : t("users.deleted")};
  });
};
